import {
  BackgroundWrapper,
  Header,
  Body,
  ContentWrapper,
} from "./Landing.styles"
import { Box } from "@mui/material"
import Button from "../../components/Button/Button"
import { useAppDispatch } from "../../app/hooks"
import { openInvoices } from "../../activeScreenSlice"

export default function Landing() {
  const dispatch = useAppDispatch()
  return (
    <BackgroundWrapper>
      <ContentWrapper>
        <Header>Welcome to Arrow</Header>
        <Body>
          Fast and reliable invoice processing, giving businesses time and space
          to focus on the other things that matter...
        </Body>
        <Box sx={{ display: "flex", gap: "16px" }}>
          <Button
            color={"--navy"}
            colorSecondary={"--white"}
            label={"Check the invoices queue"}
            variant={"contained"}
            onClick={() => dispatch(openInvoices())}
          />
          <Button
            color={"--navy"}
            colorSecondary={"--white"}
            label={"Reporting"}
            variant={"outlined"}
            onClick={() =>
              window.open(
                "https://lssdataservices.cloud.looker.com/folders/1",
                "_blank",
              )
            }
          />
        </Box>
      </ContentWrapper>


      <Box
        sx={{
          position: "absolute",
          bottom: "0px",
          left: "50%",
          transform: "translateX(-50%)",
          color: "#28005a",
          fontSize: "24px",
          fontWeight: 400,
          textAlign: "center",
        }}
      >
        Powered by <strong>Liberty Blume</strong>          
        <sup
            style={{
              fontSize: "0.5em",
              verticalAlign: "top",
            }}
          >
          ®
          </sup>
      </Box>
    </BackgroundWrapper>
  )
}
